import React, { Component } from "react";
import ReactDOM from "react-dom";
import Dropdown from "react-bootstrap/Dropdown";
import {
  GET,
  POST,
  alert,
  loading,
  linkRole,
  Status,
  Select,
  setCsrfToken,
} from "../../components/CustomComponent.js";

// Developer Mode tool: impersonate any user (super_user only, behind the PIN
// gate). Stashes the current account under scp-original-* so the Navbar "Exit"
// button can restore it. The switch itself reuses the existing switch-profile
// endpoint, so the impersonated session is byte-identical to a real login.
export default class UserImpersonation extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [], loaded: false, search: "", user_type: "" };
  }

  componentDidMount() {
    this.Get();
  }

  Get = async () => {
    loading(true);
    const result = await GET("v1/admin/users", {
      page_size: 100,
      page: 1,
      data_search: this.state.search,
      user_type: this.state.user_type,
    });
    loading(false);
    let profile = null;
    try {
      profile = JSON.parse(localStorage.getItem("scp-profile") || "null");
    } catch (e) {}
    this.setState({
      data: result?.status
        ? (result.data || []).filter((u) => u.uid !== profile?.uid)
        : [],
      loaded: true,
    });
  };

  Impersonate = async (user) => {
    const ok = await alert(
      "",
      "warning",
      "Confirm",
      `Impersonate as "${user.full_name || user.email}"?`,
      "Impersonate",
      "Cancel",
    );
    if (!ok) return;

    loading(true);
    const result = await POST("v1/admin/users/switch-profile", {
      user_id: user.uid,
      key: process.env.REACT_APP_CODE_HEX || "",
    });

    if (result?.status && result?.data?.token) {
      // Stash the real account once (so nested impersonation still returns home).
      // การ์ด #31: token จริงถูก stash เป็น httpOnly cookie (scp_original_tk) โดย backend เองแล้ว
      // (ดู switch-profile controller) ฝั่งนี้ stash แค่ข้อมูลแสดงผลที่ไม่ใช่ credential
      // csrf token หมุนใหม่พร้อมคุกกี้ชุดของ user ที่สวมสิทธิ์ ต้องเก็บทับค่าเดิมก่อนยิง request ถัดไป
      setCsrfToken(result.data.csrf_token);

      // เก็บบัญชีตั้งต้นใหม่ทุกครั้ง ยกเว้นของเดิมยังเป็น super_user (สวมสิทธิ์ super_user คนอื่นซ้อน)
      // ให้ตรงกับ backend ที่เขียนทับคุกกี้ scp_original_tk เมื่อ stash เดิมใช้ไม่ได้แล้ว
      let original = null;
      try {
        original = JSON.parse(localStorage.getItem("scp-original-profile") || "null");
      } catch (e) {}
      if (original?.user_type !== "super_user") {
        localStorage.setItem("scp-original-profile", localStorage.getItem("scp-profile") || "");
        localStorage.setItem("scp-original-2fa", localStorage.getItem("scp-2fa") || "");
      }

      // token คือ httpOnly cookie ที่ backend ตั้งมาพร้อม response นี้แล้ว ไม่ต้องเก็บเอง
      localStorage.setItem(
        "scp-profile",
        JSON.stringify({
          uid: user.uid,
          user_type: result.data.user_type || user.user_type,
          full_name: user.full_name || user.email || "User",
          email: user.email || "",
          secret: result.data.secret || "",
          is_2fa: result.data.is_2fa,
          verify_time: new Date(
            new Date().setMinutes(new Date().getMinutes() + 10),
          ).getTime(),
        }),
      );
      // Impersonation bypasses the impersonated user's 2FA (super_user grant).
      localStorage.setItem(
        "scp-2fa",
        btoa(
          user.uid +
            ":" +
            new Date(new Date().setDate(new Date().getDate() + 7)).getTime(),
        ),
      );

      window.location.href = `/${linkRole(
        result.data.user_type || user.user_type,
      )}/dashboard`;
      return;
    }

    loading(false);
    alert("", "warning", "Warning", result?.message || "Unable to impersonate.");
  };

  render() {
    const { data, loaded, search, user_type } = this.state;
    // Filter: ถ้า Developer Mode ส่งช่องใน hero มา จะ portal ขึ้นไปวางในหัว hero
    const filter = (
        <div className={`ar-toolbar ar-filter ${this.props.filterSlot ? "mt-3" : "mb-3"}`}>
          <div className="ar-filter-head">
            <span className="ar-toolbar-label">
              <span className="icon me-2">{"\uf0b0"}</span>Filter
            </span>
          </div>
          <div className="ar-filter-row">
            <div className="ar-filter-field ar-filter-field-search">
              <span className="ar-filter-label">Search</span>
          <input
            type="text"
            className="form-control"
            placeholder="Search (name / email)..."
            value={search}
            onChange={(e) => this.setState({ search: e.target.value })}
            onKeyUp={(e) => {
              if (e.key === "Enter") this.Get();
            }}
          />
            </div>
            <div className="ar-filter-field">
              <span className="ar-filter-label">Type</span>
          <Select
            className="form-control"
            placeholder="All Types"
            options={[
              { value: "", label: "All Types" },
              { value: "admin", label: "Admin" },
              { value: "accounting", label: "Accounting" },
              { value: "broker", label: "Broker" },
              { value: "sub_broker", label: "Sub Broker" },
              { value: "agent", label: "Agent" },
            ]}
            value={user_type}
            onChange={(v) =>
              this.setState({ user_type: v }, () => this.Get())
            }
            default={false}
          />
            </div>
          <div className="ar-toolbar-actions">
          <button className="ar-btn-gold" onClick={() => this.Get()}>
            <span className="icon me-2">{"\uf002"}</span>Search
          </button>
          </div>
          </div>
        </div>
    );
    return (
      <div>
        {this.props.filterSlot ? ReactDOM.createPortal(filter, this.props.filterSlot) : filter}

        <div className="ar-table-card">
          <div className="ar-table-head flex-wrap gap-2">
            <div>
              <div className="ar-table-title">
                <span className="icon me-2 pu-title-icon">{"\uf0c0"}</span>
                Users
              </div>
              <div className="ar-table-caption">
                {data.length > 0 ? `Showing ${data.length} user${data.length > 1 ? "s" : ""}` : loaded ? "No results" : "Loading..."}
                <span className="ms-2">
                  &middot; you see the same data as that user — leave via <b>Exit</b> in the Navbar
                </span>
              </div>
            </div>
            <div className="d-flex align-items-center flex-wrap gap-2">
              <button type="button" className="pu-om-ctl" onClick={() => this.Get()} title="Refresh">
                <span className="icon me-1">{"\uf2f1"}</span>Refresh
              </button>
            </div>
          </div>
        <div className="table-responsive">
          <table className="table table-hover ar-table pu-table pu-table-compact">
            <thead>
              <tr>
                <td className="text-nowrap">Code</td>
                <td className="text-nowrap">Name</td>
                <td className="text-nowrap">Email</td>
                <td className="text-nowrap">Type</td>
                <td className="text-nowrap text-center td-actions">Actions</td>
              </tr>
            </thead>
            <tbody>
              {loaded && data.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center text-secondary py-4">
                    No data
                  </td>
                </tr>
              ) : (
                data.map((u, i) => (
                  <tr key={i}>
                    <td data-label="Code" className="text-nowrap">
                      {u.user_code || "-"}
                    </td>
                    <td data-label="Name" className="text-nowrap">
                      {u.full_name || "-"}
                    </td>
                    <td data-label="Email" className="text-nowrap">
                      {u.email || "-"}
                    </td>
                    <td data-label="Type" className="text-nowrap">
                      <div className="d-flex align-items-center justify-content-center">
                          {u.user_type === "admin"
                            ? Status("admin", "success")
                            : u.user_type === "agent"
                            ? Status("agent", "info")
                            : u.user_type === "broker"
                            ? Status("broker", "purple")
                            : u.user_type === "sub_broker"
                            ? Status("sub broker", "primary")
                            : u.user_type === "accounting"
                            ? Status("accounting", "warning")
                            : Status(u.user_type, "danger")}
                        </div>
                    </td>
                    <td data-label="Action" className="text-nowrap text-center td-actions">
                      <Dropdown align="end">
                        <Dropdown.Toggle className="pu-action-toggle" id={`impersonate-actions-${i}`}>Action</Dropdown.Toggle>
                        <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                          <Dropdown.Item className="pu-action-item" data-testid="btn-impersonate" onClick={() => this.Impersonate(u)}>
                            <span className="icon">{""}</span>Impersonate
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        </div>
      </div>
    );
  }
}
